import { Spin } from 'antd'

export default function Loading() {
  return <Spin tip="加载中" fullscreen delay={10} />
}
